export default __webpack_public_path__ + "static/ico-planeta-7a9af7a5c30477f696ba48c84a64f8cc.svg";